import React from "react";
import ReactOtpInput from "react-otp-input";
import styled from "styled-components";

const StyledOtpInput = styled(ReactOtpInput)`
  input {
    outline: 0;
    height: 4.8rem;
    font-family: "NeometricBold";
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.secondary[700]};
    border-radius: 1rem;
    width: 100% !important;
    border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
    background-color: transparent;
    &:focus {
      border: 1px solid ${({ theme }) => theme.colors.secondary[700]};
    }
    &.error {
      border-color: ${({ theme }) => theme.colors.accents[100]};
    }
  }
`;

export const OtpInput = ({ value, hasError, onChange, ...props }) => (
  <StyledOtpInput
    shouldAutoFocus
    isInputNum
    numInputs={6}
    value={String(value)}
    hasErrored={hasError}
    errorStyle="error"
    containerStyle="otp-container"
    onChange={onChange}
    {...props}
    //   inputStyle={`input-style ${error ? "input-error-style" : "normal-input-style"}`}
  />
);
